<template>
	<card>
		<div class="container-fluid" style="min-height: 650px;">
			<div class="row">
				<div class="col-sm-12">
					<h5 class="back-title" @click="back()"><i class="fa fa-angle-left"></i> Back To Admin </h5>
				</div>
			</div>
			<div class="row mt-5" v-if="!isUser">
				<div class="col-xl-9 offset-xl-3">
					<h5 class="header-title pr-5">Add User Information( {{ siteName }} )</h5>
					<div class="row form-group">
						<label for="name" class="col-sm-4 text-white">Name:</label>
						<input id="name" type="text" v-model="name" class="col-sm-3 user-input" required />
					</div>
					<div class="row form-group">
						<label for="email" class="col-sm-4 text-white">Email:</label>
						<input id="email" type="text" v-model="email" class="col-sm-3 user-input" required/>
					</div>
					<div class="row form-group">
						<label for="password" class="col-sm-4 text-white">Password:</label>
						<input
							id="password"
							type="password"
							v-model="password"
							class="col-sm-3 user-input"
							required
						/>
					</div>
					<div class="row form-group">
						<label for="repassword" class="col-sm-4 text-white"
							>Re-enter Password:</label
						>
						<input
							id="repassword"
							type="password"
							v-model="repassword"
							class="col-sm-3 user-input"
							required
						/>
					</div>
					<div v-if="userMessage.length !== 0" class="row text-center form-group" style="justify-content: center;">
						<p class="error-message" v-for="message in userMessage">
							<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ message }}
						</p>
					</div>
					<div class="row form-group ml-1">
						<button @click="createUser()" class="edit-channel col-sm-2">
							Create User
						</button>
					</div>
				</div>
			</div>
			<hr v-if="!isUser"/>
			<div class="row pt-5 pb-5">
				<div class="col-xl-6 offset-xl-3">
					<h5 class="header-title pr-5">Power Manager Channels( {{ siteName }} )</h5>
					<div class="row pt-1" v-for="channel in channels">
						<div class="col-xl-1">
							<label class="site-name">{{ channel.device_order }}</label>
						</div>
						<div class="col-xl-5">
							<label class="site-name">{{ channel.device_name }}</label>
						</div>
						<div class="col-xl-3">
							<button type="button" class="edit-channel" @click="editChannel(channel)">
								<i class="fa fa-edit"></i>
								Edit Channel
							</button>
						</div>
						<div class="col-xl-3">
							<button type="button" class="edit-channel" @click="deleteChannel(channel)">
								<i class="fa fa-remove"></i>
								Delete Channel
							</button>
						</div>
					</div>
				</div>
				<div class="col-sm-12  mt-5 mb-5" v-if="isAdd">
					<div class="row ml-5 justify-content-center">
						<div class="form-group">
							<label for="channel-order" class="text-white">Order</label>
							<input id="channel-order" type="text" class="channel-order d-block h-full" v-model="channel.order"/>
						</div>
						<div class="form-group">
							<label for="channel-name" class="text-white">Channel Name</label>
							<input id="channel-name" type="text" class="channel-input d-block h-full" v-model="channel.name"/>
						</div>
						<div class="form-group">
							<label for="type" class="text-white">Channel Type</label>
							<select id="type" class="type-select d-block" v-model="channel.type">
								<option v-for="type in types" :value="type.id">
									{{ type.device_type_name }}
								</option>
							</select>
						</div>
						<div class="form-group">
							<label for="channel-name" class="text-white" style="opacity:0;">Channel Name</label>
							<button type="button" class="edit-channel d-block" @click="isAdd=false">
								Cancel
							</button>
						</div>
						<div class="form-group">
							<label for="channel-name" class="text-white" style="opacity:0;">Channel Name</label>
							<button type="button" class="edit-channel d-block" @click="addChannel">
								<i class="fa fa-plus"></i>
								Add Channel
							</button>
						</div>
					</div>
					<div class="row justify-content-center">
						<div class="form-group mt-1 mb-1" v-if="showError">
							<p class="error-message" v-for="message in messages">
								<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ message }}
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-6 offset-xl-3 pt-4" v-if="!isAdd">
					<button type="button" class="edit-channel" @click="isAdd=true">
						<i class="fa fa-plus"></i>
						Add Channel
					</button>
				</div>
			</div>
			<hr/>
			<div class="row pt-5 pb-5">
				<div class="col-xl-7 offset-xl-3">
					<h5 class="header-title pr-5">Gateways ({{ siteName }})</h5>
					<div class="row pt-1" v-for="gate in gateways">
						<div class="col-xl-6 d-flex">
							<div class="gateway-group">
								<label for="mac_address" class="text-white">Mac Address</label>
								<input id="mac_address" type="text" class="gateway-input" v-model="gate.mac_address"/>
							</div>
							<div class="gateway-group">
								<label for="offset" class="text-white">Offset</label>
								<input id="offset" type="text" class="gateway-input" v-model="gate.offset"/>
							</div>
						</div>
						<div class="col-xl-3" style="padding-top: 27px;">
							<button type="button" class="gateway-channel" @click="changeGateway(gate)">
								<i class="fa fa-edit"></i>
								Update
							</button>
						</div>
						<div class="col-xl-3" style="padding-top: 27px;">
							<button type="button" class="gateway-channel" @click="deleteGateway(gate)">
								<i class="fa fa-remove"></i>
								Delete
							</button>
						</div>
					</div>
				</div>
				<div class="col-xl-7 offset-xl-3 pl-4 mt-4 mb-4" v-if="isGatewayAdd">
					<div class="row">
						<div class="form-group">
							<label class="text-white" for="mac-address">Mac Address</label>
							<input
								class="gateway-input d-block"
								type="text"
								id="mac-address"
								v-model="newGateway.macAddress"
							/>
						</div>
						<div class="form-group">
							<label class="text-white" for="offset">Offset</label>
							<input
								class="gateway-input d-block"
								type="text"
								id="offset"
								v-model="newGateway.offset"
							/>
						</div>
						<div class="form-group" style="padding-top: 27px"> 
							<button type="button" class="gateway-channel" @click="isGatewayAdd=false">
								Cancel
							</button>
						</div>
						<div class="form-group" style="padding-top: 27px"> 
							<button type="button" class="gateway-channel" @click="createGateway">
								Create Gateway
							</button>
						</div>
					</div>
				</div>
				<div class="col-sm-6 offset-xl-3 pt-4"  v-if="!isGatewayAdd">
					<button type="button" class="edit-channel" @click="isGatewayAdd=true">
						<i class="fa fa-plus"></i>
						Add Gateway
					</button>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
import Card from "@/components/Cards/Card";
import { mapActions, mapGetters } from "vuex";
export default {
	name: 'Edit-site',
	components: {
		Card
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser'
		})
	},
	data() {
		return {
			isAdd: false,
			channels: [],
			gateways: [],
			channel_name: '',
			channel_type: '',
			siteId: '',
			siteName: '',
			name: '',
			email: '',
			password: '',
			repassword: '',
			isUser: true,
			types: [],
			channel: {
				name: '',
				type: ''
			},
			messages: [],
			userMessage: [],
			showError: false,
			userError: false,
			isGatewayAdd: false,
			newGateway: {
				macAddress: '',
				offset: 0
			},
		}
	},
	watch: {
		repassword(newValue) {
			if (this.password === newValue) {
				this.userError = false;
				this.userMessage = [];
			}
		},
	},
	async created() {
		this.siteId = this.$route.params.id;
		this.siteName = this.$route.query.name;
		let payload = {
			siteId: this.siteId,
			email: this.user.email
		}
		let result = await this.getChannels(payload);
		if (result.length > 0) {
			this.channels = result[0];
			this.gateways = result[1];
			this.isUser = result[2];
		}
		this.types = await this.getChannelAllTypes();
	},
	methods: {
		...mapActions({
			getChannels: "admin/getChannels",
			getChannelAllTypes: "admin/getChannelAllTypes",
			createChannel: "admin/createChannel",
			removeChannel: "admin/removeChannel",
			updateGateway: "admin/updateGateway",
			addGateway: "admin/addGateway",
			removeGateway: "admin/removeGateway",
			addUser: "auth/createUser"
		}),
		editChannel(channel) {
			this.$router.push({ name: "edit_channel", params: {id: channel.id, channel: channel}});
		},
		back() {
			this.$router.push({name: 'admin'});
		},
		async createUser() {
			if (this.password !== this.repassword) {
				this.showError = true;
				this.userMessage.push("Password does not match, please confirm again");
			} else {
				const user = await this.addUser({
					name: this.name, 
					password: this.password,
					email: this.email,
					admin: this.user.admin,
					siteId: this.siteId
				});
				if (!Array.isArray(user)) {
					this.$toasted.show(user.message, {
						type: "error",
						duration: 2500,
					});
				} else {
					this.$toasted.show("User is created successfully", {
						type: "success",
						duration: 2500,
					});

					this.name = '';
					this.password = '';
					this.email = '';
					this.repassword = '';
				}
			}
		},
		async addChannel() {
			this.messages = [];
			if (!this.channel.name) {
				this.messages.push("Channel Name is required");
			}

			if (!this.channel.type) {
				this.messages.push("Channel Type is required");
			}

			if (this.messages.length === 0) {
				this.showError = false;
			} else {
				this.showError = true;
			}

			if (!this.showError) {
				Object.assign(this.channel, {siteId: this.$route.params.id});
				const response = await this.createChannel(this.channel);
				
				if (Array.isArray(response)) {
					this.$toasted.show('Channel is created successfully', {
						type: "success",
						duration: 2500,
					});
					this.isAdd = false;

					let newItem = {
						device_order: this.channel.order,
						device_name: this.channel.name,
					}
					this.channels.push(newItem)
					this.types.push(newItem);
					this.channel = {
						device_order: '',
						device_name: '',
					}
				}
			}
		},
		async deleteChannel(channel) {
			let index = 0;
			this.channels.forEach((i, ind) => {
				if (i.name === channel.name) index = ind;
			});
			this.channels.splice(index, 1);
			await this.removeChannel({id: channel.id});
			this.$toasted.show('Channel is removed successfully', {
				type: "success",
				duration: 2500,
			});
		},
		async deleteGateway(gate)	{
			console.log(gate)
			let index = 0;
			let item = this.gateways.forEach((i, ind) => {
				if (i.includes === gate.id) index = ind;
			});
			this.gateways.splice(index, 1);
			await this.removeGateway({id:gate.id});

			this.$toasted.show("Gateway is deleted successfully", {
				type: "success",
				duration: 2500,
			});
		},
		async changeGateway(gate) {
			let gateway = {
				id: gate.id,
				mac_address: gate.macAddress,
				offset: gate.offset
			}
			await this.updateGateway(gateway);
			this.$toasted.show("Gateway is updated successfully", {
				type: "success",
				duration: 2500,
			});
		},
		async createGateway() {
			let gateway = {
				mac_address: this.newGateway.macAddress,
				offset: this.newGateway.offset,
				site: this.siteId
			}
			this.gateways.push(gateway);
			// this.$store.commit("auth/setGateway", gateways);
			await this.addGateway(gateway);
			this.isGatewayAdd = false;
		}
	},
}
</script>

<style lang="scss" scoped>
.error-message {
	color: #a95434;
	font-family: "Nunito Sans Light";
}
hr {
	width: 80%;
}
.user-input {
	width: 260px;
  height: 30px;
  border: 1px solid #fdfdfd;
  background-color: #1e365d;
  border-radius: 4px;
  color: white;
}
.type-select {
	width: 150px;
	height: 30px;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-color: #fdfdfd;
	border-radius: 0px;
}
.channel-input {
	height: 30px;
	width: 150px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
}

.channel-order {
	height: 30px;
	width: 50px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
}

.back-title {
	color: #4fcf8d;
	cursor: pointer;

	&:hover {
		color: #4fcf00;
		opacity: 0.8;
	}
}

.site-name {
	color: white;
	font-family: "Nunito Sans Light";
	font-weight: 100;
}
.edit-channel {
	width: 140px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	z-index: 8;
	font-size: 14px;
	font-family: 'Nunito Sans Light';
	border-radius: 2px;
	&:hover {
		background-color: #1f5881;
	}
}

.gateway-input {
	width: 140px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
}

.gateway-channel {
	width: 160px;
	height: 30px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}
</style>
